export const FORM_ELEMENT_TYPE = {
    INPUT: 'input',
    RATING: 'rating',
    TEXTAREA: 'textarea',
    TIME: 'time',
    DATE: 'date',
    UPLOADER: 'file',
    SIGNATURE: 'signature',
    BUTTON: 'button',
    HIDDEN: 'hidden',
    MULTIPLECHOICE: 'multiplechoice',
    SIMPLECHOICE: 'simplechoice',
    CHECKBOX: 'checkbox',
    NUMBER: 'number',
    HEADLINE: 'headline',
    DISPLAY: 'display',
    INPUTREGEX: 'inputregex',
    MOBILENUMBER: 'mobilenumber',
    GEOLOCATION: 'geolocation',
    ER_LOGIN_FORM: 'anmeldeformular',
    ER_LOGIN_FORM_LONG: 'anmeldeformularlong',
    ER_CONCERN_FORM: 'anliegen',
    AGB_DATENSCHUTZ: 'agbDatenschutz',
    ER_GEGNERFORMULAR: 'gegnerformular',
    RECHTSSCHUTZFORMULAR: 'rechtsschutzformular',
    AKTENRUBRUM: 'aktenrubrum',
    GEGNERFORMULARONEKFZ: 'gegnerformularohnekfz',  
    REPEATER: 'repeater',
    EXTERNAL_LINK: 'externallink',
    CUSTOM_FORM_TEMPLATE: 'customformtemplate',
    GUTACHTER_CHOICE: 'gutachterchoice'
}

export const REQUIRED_TYPE = {
    NOTEMPTY: 'NOTEMPTY',
    UPLOAD: 'UPLOAD',
    CUSTOMFORMDATE: 'CUSTOMFORMDATE',
    CUSTOMFORMTIME: 'CUSTOMFORMTIME',
    CUSTOMFORMTIMEOPTIONAL: 'CUSTOMFORMTIMEOPTIONAL',
    CUSTOMFORMRADIONOTEMPTY: 'CUSTOMFORMRADIONOTEMPTY',
    CHECKBOXREQUIRED: 'CHECKBOXREQUIRED',
    GUTACHTERREQUIRED: 'GUTACHTERNOTEMPTY',
    NUMERIC: 'NUMERIC',
    NUMERIC_OPTIONAL: 'NUMERICOPTIONAL',
    REGCHECKOPTIONAL: 'REGCHECKOPTIONAL',
    REGCHECK: 'REGCHECK',
    MOBILENUMBER: 'MOBILENUMBER',
    MOBILENUMBEROPTIONAL: 'MOBILENUMBEROPTIONAL',
    SIGNATURENOTEMPTY: 'SIGNATURENOTEMPTY',
    CUSTOMFORMGEOLOCATION: 'CUSTOMFORMGEOLOCATION',
}

export const FORM_ELEMENT_PROPS = {
    MAXLENGTH: 'maxLength',
}

export const TYPE_RATING = {
    POSITIV: 'positiv',
    NEUTRAL: 'neutral',
    NEGATIV: 'negativ',
}

export const REGEX = {
    NUMERIC: /^[0-9]+$/,
}

export const VALIDATION_PROPS = {
    KEY: {
        NOTEMPTY: 'notEmpty',
        UPLOAD: 'upload',
        CUSTOMFORMDATE: 'notEmptyDate',
        CUSTOMFORMTIME: 'notEmptyTime',
        CUSTOMFORMRADIONOTEMPTY: 'notEmptySelect',
        CHECKBOXREQUIRED: 'checked',
        NUMERIC: 'mustBeNumeric',
        NUMERIC_OPTIONAL: 'mustBeNumericOptional',
        RATING: 'notEmptyRating',
        SIMPLECHOICE: 'notEmptySimpleChoice',
        REGCHECKOPTIONAL: 'validRegexOptional',
        MAXLENGTH: 'maxLengthValidation',
        REGCHECK: 'validRegex',
        MOBILENUMBER: 'validMobileNumber',
        MOBILENUMBEROPTIONAL: 'validMobileNumberOptional',
        SIGNATURENOTEMPTY: 'notEmptySignature',
        CUSTOMFORMGEOLOCATION: 'notEmptyLocation',
    },
    VALUE: {
        NOTEMPTY: 'Pflichtfeld',
        UPLOAD: 'Bitte laden Sie eine Datei hoch',
        CUSTOMFORMDATE: 'Bitte geben Sie ein Datum an',
        CUSTOMFORMTIME: 'Bitte geben Sie eine Uhrzeit an',
        CUSTOMFORMRADIONOTEMPTY: 'Bitte wählen Sie eine der Optionen aus',
        CHECKBOXREQUIRED: 'Bitte bestätigen',
        NUMERIC: 'Bitte geben Sie eine Zahl an',
        NUMERIC_OPTIONAL: 'Bitte geben Sie eine Zahl an',
        RATING: 'Bitte geben Sie eine Bewertung ab',
        SIMPLECHOICE: 'Bitte wählen Sie Ja oder Nein aus',
        REGCHECKOPTIONAL: 'Ungültige Eingabe',
        REGCHECK: 'Ungültige Eingabe',
        MAXLENGTH: 'bitte überschreiten Sie nicht die festgelegte Zeichenanzahl',
        MOBILENUMBER: 'Bitte geben Sie eine gültige Mobilnummer an',
        MOBILENUMBEROPTIONAL: 'Bitte geben Sie eine gültige Mobilnummer an',
        SIGNATURENOTEMPTY: 'Unterschrift erforderlich',
        CUSTOMFORMGEOLOCATION: 'Ortsangabe erforderlich ',
    },
}

export const DEFAULT_PUBLIC_INFO = {
    UPLOAD: {
        maxUploadSizeInKB: 8388,
        totalFileSizeLimitInKb: 100000,
        defaultDisallowedUploadFormats:
      '8bf;a;out;apk;app;bac;bpl;bundle;class;coff;com;dcu;dol;ear;elf;expander;exe;ipa;.jar;xpi;mach-o;nlm;exe;.o;dll;s1es;so;vap;war;xbe;xap;xcoff;xex;vbx;ocx;ahk;applescript;as;au3;bat;bas;cljs;cmd;coffee;egg;egt;erb;hta;ibi;ici;ijs;ipynb;itcl;js;jsfl;lua;m;mrc;ncf;nuc;nud;nut;php;php?;pl;pm;ps1;ps1xml;psc1;psd1;psm1;py;pyc;pyo;r;rb;rdp;scpt;scptd;sdl;sh;syjs;sypy;tcl;vbs;xpl;ebuild;ada;ads; 1.ada;asm;bas;bb;bmx;c;clj;cls;cob;cpp;cs;csproj;d;dba;dbpro123;e;efs;egt;el;for; ftn; f; f77; f90;frm;frx;fth;ged;gm6;gmd;gmk;gml;go;h;hpp;hs;i;inc;java;l;lgt;lisp;m;m;m;m4;ml;n;nb;p;pas;php;piv;pl;prg;pro;pol;py;r;red;reds;rb;resx;rc;rkt;scala;sci;scm;sd7;skb;skd;skf;ski;skk;skm;sko;skp;sks;skz;sln;spin;stk;swg;tcl;vap;vb;vbg;vbp;vbproj;vcproj;vdproj;xpl;xq;xsl;y;adb;ada;s;cbl;cc;cxx;c;cbp;ftn;f;f77;f90;hxx;pp;p;php3;php4;php5;phps;phtml;pm;rc2;rktl;sce;skc;skg;skq;skt;vip;dtd;html;xhtml;mhtml;maf;asp;aspx;adp;bml;cfm;cgi;ihtml;jsp;lasso;pl;php;rna;r;rnx;ssi;ssi;atom;eml;jsonld;metalink;rss;markdown;shuttle;shtml;stm;xml;se;cmd;chm;dll;exe;scr;bat;asp;php;mdb;sql;js;pl;py;vbs;vbe;jse;wsf;com;wsh;msi;htm;html;aspx;ashx;asmx;wcf;ade;adp;asa;ashx;asmx;asp;bas;bat;cdx;cer;chm;class;cmd;cnt;com;config;cpl;crt;csh;der;dll;exe;fxp;gadget;grp;hlp;hpj;hta;htr;htw;ida;idc;idq;ins;isp;its;jse;json;ksh;lnk;mad;maf;mag;mam;maq;mar;mas;mat;mau;mav;maw;mcf;mda;mdb;mde;mdt;mdw;mdz;ms-one-stub;msc;msh;msh1;msh1xml;msh2;msh2xml;mshxml;msi;msp;mst;ops;pcd;pif;pl;prf;prg;printer;ps1;ps1xml;ps2;ps2xml;psc1;psc2;pst;reg;rem;scf;scr;sct;shb;shs;shtm;shtml;soap;stm;svc;url;vb;vbe;vbs;vsix;ws;wsc;wsf;wsh;xamlx;ade;adp;and;asf;lsf;lsx;atf;bas;bat;cab;cer;crt;der;chm;cmd;com;cpl;crl;css;dll;dochtml;dot;dothtml;dsm;far;it;stm;ult;wma;dun;eml;email;exe;fav;hlp;ht;htt;hta;htm;html;ini;ins;isp;jar;jav;java;js;jse;lnk;desklink;mad;maf;mda;mas;mag;mam;maq;mar;mat;mav;maw;mdn;mdt;mdx;mdb;mdbhtml;mde;mhtml;mhtm;mim;msc;mmf;msi;msp;mst;nws;pdc;pif;pl;prf;ppa;pot;ppthtml;pothtml;pst;py;reg;scf;scp;scr;shs;shb;slk;stl;swf;spl;url;vb;vbe;vbs;vxd;wbk;wiz',
    },
}

export const DEFAULT_LOCALIZED = {
    formElementSimpleChoiceYesOption: 'Yes',
    formElementSimpleChoiceNoOption: 'No',
    agbStatement:
    'Die Nutzungbedingungen für das vorliegende Angebot habe ich verstanden und bin damit einverstanden.',
    datenschutzStatement:
    'Die Hinweise zum Datenschutz habe ich zur Kenntnis genommen, mit der Verarbeitung wie dort geschrieben bin ich einverstanden.',
    showStatementTitle: true,
    datenschutzText: 'Datenschutz',
    agbText: 'AGB',
    confirmTextExternalLinkPopUp: 'Wenn Sie dies anklicken, verlassen Sie diese Website und werden auf eine externe Website weitergeleitet. Möchten Sie fortfahren?',
}
